// Suspense fallback for the lazily loaded app shell in index.tsx. Deliberately built from plain markup and
// index.css instead of components/Loading/SceneLoader: that component imports the baseComponents barrel and
// globalStyles, which would pull Fluent UI and the shared model tree straight back into the boot bundle.
const BootSpinner = () => {
  return (
    <div className="boot-spinner">
      <div className="boot-spinner-circle" />
    </div>
  );
};

export default BootSpinner;
